import React, { useState } from "react";
import loanservice from "../assets/images/loanservice.svg";
import insuranceservice from "../assets/images/insuranceservice.png";
import investmentservice from "../assets/images/investmentservice.svg";
import portfolioservice from "../assets/images/portfolioservice.svg";
import wealthservice from "../assets/images/wealthservice.png";
import equityservice from "../assets/images/equityservice.png";
import realestateservice from "../assets/images/realestateservice.png";
import { motion } from "framer-motion";
import { ListGroup, ListGroupItem } from "reactstrap";
import "flip-card-wc";
// import '../App.css'

const listmotion = {
  hidden: {
    opacity: 0,
    x: "-1vw",
  },
  visible: {
    opacity: 1,
    overflow: "hidden",
    x: 0,
    transition: {
      delay: 0.3,
      type: "spring",
      stiffness: "120",
    },
  },
};

const styles = {
  height: "18em",
  width: "16em",
  // background:`URL(${animatedbg})`,
  background: "#02223D",
  borderRadius: "1.5em",
};
const contstyles = {
  height: "18em",
  width: "16em",
  // background:`URL(${animatedbg})`,
  background: "#011a27",
  borderRadius: "1.5em",
};

const liststyle = {
  listStyleType: "none",
  fontWeight: "700",
  margin: "auto 0",
  padding: 0,
};
const listitemstyle = {
  width: "100%",
  color: "#fff",
  fontSize: "1rem",
  marginBottom: "0.3em",
};

const Cards = ({ title, image, desc }) => {
  const checkimage = (prop) => {
    switch (prop) {
      case "loanservice":
        return loanservice;
      case "insuranceservice":
        return insuranceservice;
      case "investmentservice":
        return investmentservice;
      case "wealthservice":
        return wealthservice;
      case "portfolioservice":
        return portfolioservice;
      case "equityservice":
        return equityservice;
      case "realestateservice":
        return realestateservice;
    }
  };

  const [hover, setHover] = useState(false);
  return (
    <div
      className="card  col-8 col-lg-3 col-md-4 mb-2 m-md-2 mx-sm-auto "
      style={contstyles}
    >
      <flip-card
        variant="hover"
        className="service-card w-100"
        style={{ borderRadius: "1em" }}
      >
        <div
          slot="front"
          className="front card w-100 border border-warning border-3   p-2"
          onMouseEnter={() => {
            setHover(true);
          }}
          onClick={() => {
            setHover(true);
          }}
          style={styles}
        >
          <img
            className="card-img-center my-auto"
            src={checkimage(image)}
            alt={image}
          />
          <h5 className="card-title align-bottom  fw-bold">{title}</h5>
        </div>
        <div
          slot="back"
          style={styles}
          className="card w-100 border border-warning border-3 rounded-5 p-2"
          onMouseLeave={() => {
            setHover(false);
          }}
        >
          <motion.ul
            variants={listmotion}
            initial="hidden"
            animate="visible"
            style={liststyle}
            class="listitem"
          >
            {desc.map((d) => (
              <li style={listitemstyle}>{d}</li>
            ))}
          </motion.ul>
        </div>
      </flip-card>
    </div>
  );
};

export default Cards;
